"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = '5.0.35';
//# sourceMappingURL=version.js.map